import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ServiceTimeContributionComponent from "../../../components/SidebarMenuComponents/ReportComponent/ServiceTimeContributionComponent";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServiceTimeReportPage() {
    const location = useLocation();
   

    return (
        <Page title="  Service Time Contribution Report | tiketic" >
           
            <StickyHeader title="Service Time Contribution Report" />

            <ContentStyle>
                <ServiceTimeContributionComponent/>
            </ContentStyle>
        </Page>
    );
}

